import { ia, iaRa } from 'lib/helpers/utility';

import { renderItemType } from 'components/practice/BeyondBilling/ElectronicInvoicing/lib/renderType';
import {
  calcInvoiceDiscountFromProducts,
  calculateInvoiceTaxFromItems
} from 'components/practice/NewAppointment/components/Sections/Pricing/components/ProceduresProduct/components/SelectedItems/helpers';

export const getTransactionItems = (transaction) => {
  const { invoice } = transaction || {};

  return [...iaRa(invoice?.procedures), ...iaRa(invoice?.products), ...iaRa(invoice?.packages)];
};

export const buildTransactionItems = (transaction) => {
  const items = getTransactionItems(transaction);

  return iaRa(items).map((item) => {
    const { pt_balance, total_cost_cents, amount_cents, discount, type, invoiceId } = item || {};

    const price = pt_balance ?? total_cost_cents ?? amount_cents ?? 0;
    let discountValue = discount?.amount_cents || 0;
    let taxAmount = calculateInvoiceTaxFromItems({ mergedItems: [item] });

    const isService = type || invoiceId;

    if (item?.products?.length || item?.procedures?.length) {
      taxAmount = calculateInvoiceTaxFromItems(item);

      const invoiceDiscount = calcInvoiceDiscountFromProducts(item);
      discountValue = invoiceDiscount?.amount_cents || 0;
    }

    const quantity =
      (isService ? (item?.quantity ?? item?.units ?? item?.sales_count) : item?.sales_count) || 1;

    return {
      ...item,
      itemType: renderItemType(item),
      price,
      quantity,
      discount: discountValue,
      tax: taxAmount,
      total: Math.round(price * quantity - discountValue + taxAmount)
    };
  });
};

export const hasTransactionItems = (transaction) => ia(getTransactionItems(transaction));
